import { createFileRoute } from '@tanstack/react-router';
import SafetyObservationList from '@/components/features/compliance/components/safety-observation-list';

export const Route = createFileRoute('/_authenticated/compliance/safety')({
  component: SafetyObservationList,
});
